import { useLayoutEffect, useMemo } from "react"
import { getStudent } from "./api"
import useFetchItemById from "../../../../queries/useFetchItemById"

export default function useStudentResource({id, method = 'view'}){

    const {
        data: studentData,
        fetchData: fetchStudentData,
        isLoading: isFetching,
    } = useFetchItemById({ fetcher:  getStudent, moduleName: method, payLoad: {} })

    const isLoadingResources = useMemo(() => {
        return isFetching === true
    }, [
        isFetching
    ])
    

    useLayoutEffect(()=>{fetchStudentData({id: id})}, [fetchStudentData])

    return {
        id,
        studentData,
        isLoadingResources,
        fetchStudentData,
    }
}